import React, { useEffect, useState } from 'react';
import {  Button, Spinner, Row, Col, Form, Badge } from 'react-bootstrap';
import {  toast } from 'react-toastify';
import { getAll } from '../../services/Users/Users';
import { getCategories } from '../../services/Configs/ItemCategoriesService';
import { getLocations } from '../../services/Configs/LocationsService';
import { getStatuses } from '../../services/Other/GeneralQueries';
import { getAllSubCategories } from '../../services/Configs/ItemSubCategoriesService';
import { serviceAddItem } from '../../services/Items/AddItem';
import { uploadItemFiles } from '../../services/Items/UploadFiles';
import { useNavigate } from 'react-router-dom';

const getDate = () => new Date().toISOString().slice(0, 10);
const getUserId = () => sessionStorage.getItem('userId') ?? 0;
function AddItem(){ 
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [locations, setLocations] = useState([]);
    const [statuses, setStatuses] = useState([]);
    const [users, setUsers] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    
    // Tipos MIME permitidos para archivos
    const allowedFileTypes = [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif',
        'image/webp',
        'application/pdf',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ];
    
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        categoryId: 0,
        subcategoryId: 0,
        quantity: '1',
        unitPrice: '0',
        locationId: 0,
        barcode: '',
        tag: '',
        statusId: 0,
        brand: '',
        model: '',
        additionalNotes: '',
        dimensions: '',
        weight: '',
        unitOfWeightMeasurement: '',
        acquisitionDate: getDate(),
        userId: getUserId(),
        serialNumber: '',
        partNumber: '',
        assignedToUserId: 0
    });
    
    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        
        // Validar tipos de archivo
        const invalidFiles = files.filter(file => !allowedFileTypes.includes(file.type));
        
        if (invalidFiles.length > 0) {
            toast.error('Algunos archivos tienen formatos no permitidos');
            return;
        }
        
        setSelectedFiles(files);
    };
    
    const handleSubmit = (e) => {
        e.preventDefault();  
        let pendingInputs = [];
        if(!formData.name)
        {
            pendingInputs.push("Nombre");
        }
        if(formData.categoryId == 0 || formData.categoryId == '0')
        {
            pendingInputs.push("Categoría");
        }
        if(!formData.quantity)
        {
            pendingInputs.push("Cantidad de objetos");
        }
        // if(!formData.unitPrice)
        // {
        //     pendingInputs.push("Costo unitario $");
        // }
        if(formData.locationId == 0 || formData.locationId == '0')
        {
            pendingInputs.push("Ubicación");
        }
        if(formData.statusId == 0 || formData.statusId == '0')
        {
            pendingInputs.push("Estatus");
        }
        if(formData.weight)
        {
            if(!formData.unitOfWeightMeasurement)
            {
                pendingInputs.push("Unidad de medida")
            }
        }



        
        if(pendingInputs.length == 0)
        {
            setIsButtonDisabled(true);
            
            // Paso 1: Crear el item
            serviceAddItem(formData).then(addItemResult => {
                if(addItemResult.result && addItemResult.id)
                {
                    // Paso 2: Si hay archivos, subirlos
                    if(selectedFiles.length > 0)
                    {
                        uploadItemFiles(addItemResult.id, selectedFiles).then(uploadResult => {
                            if(uploadResult.result)
                            {
                                toast.success('Se creó correctamente el objeto con sus archivos');
                            }
                            else
                            {
                                toast.warning('El objeto se creó pero hubo un error al subir los archivos');
                            }
                            
                            setTimeout(() => {
                                navigate('/Inventory'); 
                            }, 1500);
                        }).catch(error => {
                            toast.warning('El objeto se creó pero hubo un error al subir los archivos');
                            setTimeout(() => {
                                navigate('/Inventory'); 
                            }, 1500);
                        });
                    }
                    else
                    {
                        // No hay archivos, solo mostrar éxito y redirigir
                        toast.success('Se creó correctamente');
                        setTimeout(() => {
                            navigate('/Inventory'); 
                        }, 1500);
                    }
                }
                else
                {
                    toast.error('Error al crear el objeto');
                    setIsButtonDisabled(false);
                }
            }).catch(error => {
                toast.error('Error al crear el objeto');
                setIsButtonDisabled(false);
            });
        }
        else
        {
            toast.warning(`Lo sentimos, debes completar los siguientes campos: ${pendingInputs.join(', ')}`)
        }
       

    }
    const redirectBack = () => {
        navigate('/Inventory');
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value,
        });
        if(name === "categoryId")
        {
            if(parseInt(value) === 0)
            {
                setSubCategories([]);
            }
            else
            {
                getAllSubCategories(parseInt(value)).then(subList => {
                    setSubCategories(subList);
                })
            }
        }
    };

    useEffect(() => {
        getCategories().then(list=>{
            setCategories(list);
        });
        getLocations().then(list=>{
            setLocations(list);
        });
        getStatuses().then(list=>{
            setStatuses(list);
        });
        getAll().then(list=> {
            setUsers(list);
        });
    },[]);
    return (
    <>
    <Row className='justify-content-center'>
        <Col xl={12}>
        <Form onSubmit={handleSubmit}>
                <Row className='mt-3' >
                    <Col>
                        <Form.Group controlId="">
                        <Form.Label>Nombre *:</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col>
                        <Form.Group controlId="">
                        <Form.Label>Descripción:</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            name="description"
                            value={formData.description}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="">
                        <Form.Label>Notas adicionales:</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            name="additionalNotes"
                            value={formData.additionalNotes}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col xl={4} className=''  >
                            <Form.Label>Fecha de adquisición:</Form.Label>
                                <Form.Group controlId="formEmail">
                                <Form.Control
                                    type="date"
                                    name="acquisitionDate"
                                    placeholder=''
                                    value={formData.acquisitionDate}
                                    onChange={handleInputChange}                              
                                />
                        </Form.Group>
                    </Col>
                    <Col xl={4} >
                        <Form.Group controlId="">
                        <Form.Label>Cantidad de objetos *:</Form.Label>
                        <Form.Control
                            type="text"
                            name="quantity"
                            value={formData.quantity}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                    <Col xl={4}>
                        <Form.Group controlId="">
                        <Form.Label>Costo unitario $:</Form.Label>
                        <Form.Control
                            type="text"
                            name="unitPrice"
                            placeholder='$'
                            value={formData.unitPrice}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col xl={6}>
                        <Form.Group controlId="formRole">
                            <Form.Label>Categoría *:</Form.Label>
                            <Form.Control
                                as="select"
                                name="categoryId"
                                value={formData.categoryId}
                                onChange={handleInputChange}
                            >
                                <option key={0} value={0}>Seleccionar categoría</option>
                                {categories.map((category) => (
                                        <option key={category.id} value={category.id}>{category.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col xl={6}>
                        <Form.Group controlId="formRole">
                            <Form.Label>Subcategoría:</Form.Label>
                            <Form.Control
                                as="select"
                                name="subcategoryId"
                                value={formData.subcategoryId}
                                onChange={handleInputChange}
                            >
                                <option key={0} value={0}>Seleccionar subcategoría</option>
                                {subCategories.map((category) => (
                                        <option key={category.id} value={category.id}>{category.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col xl={6}>
                        <Form.Group controlId="">
                            <Form.Label>Ubicación *:</Form.Label>
                            <Form.Control
                                as="select"
                                name="locationId"
                                value={formData.locationId}
                                onChange={handleInputChange}
                            >
                                <option key={0} value={0}>Seleccionar ubicación</option>
                                {locations.map((location) => (
                                        <option key={location.id} value={location.id}>{location.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col xl={6}>
                        <Form.Group controlId="">
                            <Form.Label>Estatus *:</Form.Label>
                            <Form.Control
                                as="select"
                                name="statusId"
                                value={formData.statusId}
                                onChange={handleInputChange}
                            >
                                <option key={0} value={0}>Seleccionar el estatus del objeto</option>
                                {statuses.map((status) => (
                                        <option key={status.id} value={status.id}>{status.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col>
                        <Form.Group controlId="">
                        <Form.Label>Asignado a:</Form.Label>
                            <Form.Control
                                as="select"
                                name="assignedToUserId"
                                value={formData.assignedToUserId}
                                onChange={handleInputChange}
                            >
                                <option key={0} value={0}>Sin asignar</option>
                                {users.map((user) => (
                                        <option key={user.id} value={user.id}>{user.userName} - {user.email}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>                       
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col>
                        <Form.Group controlId="">
                        <Form.Label>Código de barras:</Form.Label>
                        <Form.Control
                            type="text"
                            name="barcode"
                            value={formData.barcode}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col>
                    <Form.Group controlId="">
                        <Form.Label>Serial Number:</Form.Label>
                        <Form.Control
                        type="text"
                        name="serialNumber"
                        value={formData.serialNumber}
                        onChange={handleInputChange}
                        />
                    </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col>
                    <Form.Group controlId="">
                        <Form.Label>Part Number:</Form.Label>
                        <Form.Control
                        type="text"
                        name="partNumber"
                        value={formData.partNumber}
                        onChange={handleInputChange}
                        />
                    </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col>
                        <Form.Group controlId="">
                        <Form.Label>Etiqueta:</Form.Label>
                        <Form.Control
                            type="text"
                            name="tag"
                            value={formData.tag}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                </Row>
    
                <Row className='mt-3' >
                    <Col>
                        <Form.Group controlId="">
                        <Form.Label>Marca:</Form.Label>
                        <Form.Control
                            type="text"
                            name="brand"
                            value={formData.brand}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col>
                        <Form.Group controlId="">
                        <Form.Label>Modelo:</Form.Label>
                        <Form.Control
                            type="text"
                            name="model"
                            value={formData.model}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col>
                        <Form.Group controlId="">
                        <Form.Label>Dimensiones:</Form.Label>
                        <Form.Control
                            type="text"
                            name="dimensions"
                            value={formData.dimensions}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col xl={6}>
                        <Form.Group controlId="">
                        <Form.Label>Peso *:</Form.Label>
                        <Form.Control
                            type="text"
                            name="weight"
                            value={formData.weight}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                    <Col xl={6}>
                    <Form.Group controlId="">
                            <Form.Label>Unidad de medida:</Form.Label>
                            <Form.Control
                                as="select"
                                name="unitOfWeightMeasurement"
                                value={formData.unitOfWeightMeasurement}
                                onChange={handleInputChange}
                            >
                                <option key={0} value={null}>Seleccionar el estatus del objeto</option>
                                <option key={0} value="KG">KG</option>
                                <option key={0} value="LB">LB</option>
                               
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col>
                        <Form.Group controlId="formFiles">
                            <Form.Label>Adjuntar archivos (opcional):</Form.Label>
                            <Form.Control
                                type="file"
                                multiple
                                accept=".jpg,.jpeg,.png,.gif,.webp,.pdf,.xls,.xlsx,.doc,.docx"
                                onChange={handleFileChange}
                            />
                            <Form.Text className="text-muted">
                                Formatos permitidos: Imágenes (JPG, PNG, GIF, WEBP), PDF, Excel (XLS, XLSX), Word (DOC, DOCX)
                            </Form.Text>
                        </Form.Group>
                        {selectedFiles.length > 0 && (
                            <div className="mt-2">
                                <strong>Archivos seleccionados:</strong>
                                <ul>
                                    {selectedFiles.map((file, index) => (
                                        <li key={index}>{file.name} ({(file.size / 1024).toFixed(2)} KB)</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </Col>
                </Row>
                <Row className='justify-content-center mt-2'>
                    <Col xl={6} className='text-center'>
                        <Button className='m-3' variant="secondary" type="button" onClick={redirectBack} disabled={isButtonDisabled}>
                            Cancelar
                        </Button>
                        <Button className='m-3' variant="primary" type="submit" disabled={isButtonDisabled}>
                            {isButtonDisabled ? 'Creando...' : 'Crear objeto'}
                        </Button>
                    </Col>
                    
                </Row>
            </Form>
        </Col>
    </Row>      
      </>
    )
}
export default AddItem